module.exports = __webpack_public_path__ + "media/common/images/badges/active/dotahovac-f62f9f5cbf94bc166957fab960c7032b.svg";